import * as React from 'react';
import SUIChartPie from '@splunk/react-icons/enterprise/ChartPie';

const Pie = (
    // eslint-disable-next-line no-undef
    props: Omit<React.ComponentProps<typeof SUIChartPie>, 'screenReaderText'>
): React.ReactElement<SVGElement> => <SUIChartPie {...props} screenReaderText={null} />;

export default Pie;
